import forge from 'node-forge'

export default function encryptRSA(payload) {
  const payloadString = JSON.stringify(payload)

  const aesKey = forge.random.getBytesSync(32)

  const iv = forge.random.getBytesSync(16)

  const cipher = forge.cipher.createCipher('AES-CBC', aesKey)
  cipher.start({ iv })
  cipher.update(forge.util.createBuffer(payloadString))
  cipher.finish()
  const encryptedPayload = cipher.output.getBytes()

  console.debug('🚀 ~ encryptRSA ~ import.meta.env.VITE_ENCRYPTION_KEY:', import.meta.env.VITE_ENCRYPTION_KEY)
  const publicKey = forge.pki.publicKeyFromPem(import.meta.env.VITE_ENCRYPTION_KEY)

  const encryptedKey = publicKey.encrypt(aesKey, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: forge.mgf1.create(),
  })

  return {
    encryptedPayload: forge.util.encode64(encryptedPayload),
    encryptedKey: forge.util.encode64(encryptedKey),
    iv: forge.util.encode64(iv),
  }
}
